@use "sass:color";
@use "sass:string";

// Use CSS custom properties (variables) for colors. Sass is only used
// here because we have it anyways and it lets us avoid repeating ourselves.

// hex, camelCase, kebab-case
$colors: (
    // Called "Primary Colors" in design doc
    (#000, "trueBlack", "true-black"),
    (#202020, "black", "black"),
    (#fff, "white", "white"),
    (#a21010, "red", "red"),
    // "Secondary Colors"
    (#655951, "brown", "brown"),
    (#8e827e, "brownGray", "brown-gray"),
    (#e5e2d9, "offWhite", "off-white"),
    (#f5f3f0, "lightBeige", "light-beige"),
    (#363430, "darkBrown", "dark-brown"),
    // "System Colors"
    (#575554, "mediumGray", "medium-gray"),
    (#807e7d, "gray", "gray"),
    (#bfbfbe, "lightGray", "light-gray"),
    (#dfdfdf, "whiteGray", "white-gray"),
    (#a21010, "errorRed", "error-red")
);

// This file should ONLY be exporting colors. This approach lets us keep the
// color swatch story up to date automatically.
:export {
    @each $color, $camel, $kebab in $colors {
        $rgb: color.channel($color, "red")
            color.channel($color, "green")
            color.channel($color, "blue");

        // If you need the base variables to be accessible in JavaScript,
        // uncomment this line.
        // #{unquote($camel)}Base: #{$rgb};
        #{string.unquote($camel)}: #{"rgb" }($rgb);
    }
}

:root[data-design-version="v2024"] {
    @each $color, $camel, $kebab in $colors {
        $rgb: color.channel($color, "red")
            color.channel($color, "green")
            color.channel($color, "blue");

        --#{string.unquote($kebab)}-base: #{$rgb};
        --#{string.unquote($kebab)}: rgb(var(--#{$kebab}-base));
    }
}
